var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBookOpen = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#book-open_svg__a)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 2.75C6 1.81 8.427 1.044 11.245 1a.25.25 0 0 1 .255.25V9a.25.25 0 0 1-.246.25C8.43 9.293 6 10.06 6 11c0-.94-2.432-1.706-5.254-1.75A.25.25 0 0 1 .5 9V1.25A.25.25 0 0 1 .754 1C3.572 1.044 6 1.81 6 2.75Z",
  stroke: "#A4A4A4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 2.749v8.187",
  stroke: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "book-open_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgBookOpen);
export default ForwardRef;